module.exports = __webpack_public_path__ + "img/appAsset-http--404.0b36f331.svg";